import {
  Avatar,
  Badge,
  Button,
  Col,
  Drawer,
  Dropdown,
  Image,
  Menu,
  message,
  Modal,
  Row,
  Space,
  Typography,
  Popover,
  Spin,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useEffect, useRef, useState } from "react";
import AmpSvg from "../../../assests/amp_logo.svg";
import LoginSvg from "../../../assests/login-icon.svg";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import {
  CloseOutlined,
  DownOutlined,
  MenuOutlined,
  UserOutlined,
} from "@ant-design/icons";
import RFPModal from "../../modal/rfp-request-modal/RfpRequestModal";
import AdvertiseModal from "../../modal/advertise-with-amp/AdvertiseModal";
import Notification from "../../../assests/notification_icon.png";
import CartIcon from "../../../assests/cart_icon.svg";
import { ReactComponent as ChatNotification } from "../../../assests/chat-nofication.svg";
import "./NavBar.css";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../store/slices/auth/LoginSlice";
import { ReactComponent as AccountIcon } from "../../../assests/account-icon.svg";
import { ReactComponent as BillingAndPaymentIcon } from "../../../assests/BillingAndPaymentIcon.svg";
import { ReactComponent as DashboardIcon } from "../../../assests/DashBoardIcon.svg";
import { ReactComponent as LogoutIcon } from "../../../assests/LogoutIcon.svg";
import { ReactComponent as TermsRequestIcon } from "../../../assests/terms-request.svg";
import { ReactComponent as CartIcons } from "../../../../src/assests/cart_icon.svg";
import { ReactComponent as SavedCampaigns } from "../../../../src/assests/saved_campaign.svg";
import { ReactComponent as Aggrements } from "../../../../src/assests/aggrements-icon.svg";
import { ReactComponent as Browse } from "../../../../src/assests/browse-icon.svg";
import { ReactComponent as BackArrow } from "../../../assests/back-arrow.svg";
import { ReactComponent as RFPIcon } from "../../../assests/rfp-icon.svg";
import { API_BASE_URL_IMAGE } from "../../../services/common";
import {
  getChatHistory,
  getNotifications,
  getUserProfile,
} from "../../../store/thunks/common-thunks/commonThunk";
import { RESET_USER } from "../../../store/slices/auth/UserProfileSlice";
import RfpMobileVersion from "../../modal/rfp-request-modal/RfpVersion";
import AdvertiseVersion from "../../modal/advertise-with-amp/AdvertiseModalVersion";
import { ReactComponent as EnquiryChat } from "../../../assests/enquiry-chat-icon-black.svg";
import { cartDetails } from "../../../store/thunks/buyer-thunks/BuyerThunks";
import {
  clearAllFilters as clearAllProductFilters,
  setMapView,
  setSearchText,
} from "../../../store/slices/common-slice/product-filters/ProductFilter";
import "../../../main.css";
import NotificationPopoverContent from "../../common/notification-popover-content/NotificationPopoverContent";
import { nanoid } from "nanoid";
import {
  resetBreadcrumbs,
  setBreadcrumbs,
} from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { ChatBoxModal } from "../../modal/chat-box-communication/ChatBoxModal";
import { setIsChatModal } from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";
import { clearLiveMsgNotification } from "../../../store/slices/common-slice/web-sockets/WebSocketMsgSlice";
import { disconnectWebSocket } from "../../common/utils/WebSocket";
import { Tooltip } from "antd";
const { Text } = Typography;
const NavBar = ({
  isLoggedIn,
  userRole,
  Advertise,
  SetAdvertise,
  setSelectedImage,
  selectedImage,
  form,
}) => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [menuItems, setMenuItems] = useState([]);
  const [visible, setVisible] = useState(false);
  const isMobile = useMediaQuery({ minWidth: 0, maxWidth: 768 });
  const isTab = useMediaQuery({ minWidth: 769, maxWidth: 1024 });
  const [RFP, setRFP] = useState(false);
  const [adVersionOpen, setAdVersionOpen] = useState(false);
  const { user } = useSelector((state) => {
    const userProfile = state.userprofile;
    return {
      ...userProfile,
    };
  });
  const { isProductChat } = useSelector(
    (state) => state.chatCommunicationHandleSlice,
  );
  const { isLiveMsgNotification } = useSelector((state) => state.webSocketMsgs);
  const [openNotificationPopover, setOpenNotificationPopover] = useState(false);
  const { campaignCartDetails, isCartLoading } = useSelector(
    (state) => state.campaignscart,
  );
  const { termsPlanSelected } = useSelector((state) => state?.payment);
  const breadcrumbs = useSelector((state) => state.breadcrumb);
  const { userType } = useSelector((state) => state.login);
  const [openRfpVersion, setOpenRfpVersion] = useState(false);
  const [selectedTransferProducts, setSelectedTransferProducts] = useState([]);
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState({
    name: false,
    email: false,
  });
  const handleGoToSubPage = ({ title, path }) => {
    dispatch(
      resetBreadcrumbs({
        title,
        path,
      }),
    );
  };
  const showAllNotifications = () => {
    setOpenNotificationPopover(false);

    if (userRole === "owner") {
      handleGoToSubPage({
        title: "Notifications",
        path: "/seller/notifications",
      });
      navigate("/seller/notifications");
    } else {
      handleGoToSubPage({
        title: "Notifications",
        path: "/buyer/notifications",
      });
      navigate("/buyer/notifications");
    }
  };
  const notificationHeader = (
    <div className="notification-title">
      <div className="header">Notifications</div>
      <div className="see-all-link pointer" onClick={showAllNotifications}>
        {" "}
        See all
      </div>
    </div>
  );
  const [profileDropdown, setProfileDropdown] = useState(false);
  const showDrawer = () => setVisible(true);
  const closeDrawer = () => setVisible(false);
  const basePath = useRef();
  const { notification_count, notifications } = useSelector(
    (state) => state?.notifications,
  );
  const notificationContent = (
    <NotificationPopoverContent
      notificationCount={notification_count}
      notificationsList={notifications}
      setOpenNotificationPopover={setOpenNotificationPopover}
    />
  );

  const goToSubPage = ({ title, path }) => {
    const updatedCrumbs =
      breadcrumbs &&
      breadcrumbs?.filter((crumb) => !/^[a-z0-9]{8,}$/i.test(crumb.path));
    // Add Cart crumb
    updatedCrumbs.push({
      title,
      path,
    });
    dispatch(resetBreadcrumbs(updatedCrumbs));
  };

  // let basePath;
  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getNotifications());
      basePath.current = userRole === "owner" ? "/seller" : "/buyer";
      if (basePath.current === "/seller") {
        setMenuItems([
          { key: `${basePath.current}/dashboard`, label: "Dashboard" },
          { key: `${basePath.current}/myproducts`, label: "My Products" },
          {
            key: `${basePath.current}/viewCampaigns?segment=insertion_order`,
            label: "Campaigns",
          },
          { key: `${basePath.current}/rfpRequests`, label: "RFP Requests" },
          { key: `${basePath.current}/messages`, label: "Messages" },
          ...(isMobile
            ? [
                {
                  key: `${basePath.current}/personaldetails`,
                  label: "My Profile",
                },
                // for the future use
                // {
                //   key: `${basePath.current}/payments`,
                //   label: "Billing and Payments",
                // },
                {
                  key: `${basePath.current}/terms-requests`,
                  label: "Buyer Requests",
                },
              ]
            : []),
        ]);
      } else {
        dispatch(cartDetails("campaignCart"));
        setMenuItems([
          { key: `${basePath.current}/dashboard`, label: "Dashboard" },
          { key: `${basePath.current}/products`, label: "Shop" },
          {
            key: `${basePath.current}/mycampaigns?segment=saved_campaign`,
            label: "Campaigns",
          },
          { key: `${basePath.current}/messages`, label: "Messages" },
          ...(isMobile
            ? [
                {
                  key: `${basePath.current}/personaldetails`,
                  label: "My Profile",
                },
                {
                  key: `${basePath.current}/viewcart`,
                  label: "Cart",
                },
                // for the future use
                // {
                //   key: `${basePath.current}/payments`,
                //   label: "Billing and Payments",
                // },
                {
                  key: `${basePath.current}/privacy-policy`,
                  label: "User Agreements",
                },
              ]
            : []),
          ...(isMobile
            ? [
                {
                  label: "Advertise with AMP",
                },
                {
                  label: "RFP",
                },
              ]
            : []),
        ]);
      }
    } else {
      // Show default menu before login
      setMenuItems([
        { key: "/home", label: "Home" },
        { key: "/products", label: "Shop" },
        { key: "/about", label: "About" },
        { key: "/contact", label: "Contact" },
        ...(isMobile
          ? [{ label: "Advertise with AMP" }, { label: "Get in Touch" }]
          : []),
      ]);
    }
  }, [isLoggedIn, userRole, isMobile, dispatch]);

  const handleMenuClick = (e) => {
    const clickedItem = menuItems?.find((item) => item.key === e.key);

    dispatch(
      resetBreadcrumbs({
        title: clickedItem.label,
        path: clickedItem.key,
      }),
    );
    navigate(clickedItem.key);
  };

  useEffect(() => {
    <Menu
      items={menuItems}
      onClick={({ key, item }) => {
        if (item?.label === "Advertise with AMP") {
          SetAdvertise(true);
        } else {
          navigate(key); // assuming you're using react-router
        }
      }}
    />;
  }, []);

  const handlePersonalDetails = () => {
    navigate(`${userRole === "owner" ? "/seller" : "/buyer"}/personaldetails`);
    setProfileDropdown(!profileDropdown);
  };

  const handleChatClick = (product) => {
    dispatch(getChatHistory({ campaignId: null, bookingId: null }));
    dispatch(setIsChatModal(true));

    dispatch(clearLiveMsgNotification());
    // dispatch(setCampaignInfoForChat(selectedCampaignDetails));
    if (isMobile) {
      navigate("/seller/campaign-chat-list");
    }
  };

  const handleCart = () => {
    if (location.pathname === "/home") {
      handleGoToSubPage({
        title: "Cart",
        path: `${userRole === "owner" ? "/seller" : "/buyer"}/viewcart`,
      });
      navigate(`${userRole === "owner" ? "/seller" : "/buyer"}/viewcart`);
      setProfileDropdown(!profileDropdown);
    }

    handleGoToSubPage({
      title: "Cart",
      path: `${userRole === "owner" ? "/seller" : "/buyer"}/viewcart`,
    });
    navigate(`${userRole === "owner" ? "/seller" : "/buyer"}/viewcart`);
    setProfileDropdown(!profileDropdown);
  };
  const handleDashBoard = () => {
    dispatch(
      resetBreadcrumbs({
        title: "Dashboard",
        path: `${userRole === "owner" ? "/seller" : "/buyer"}/dashboard`,
      }),
    );
    // goToSubPage();
    navigate(`${userRole === "owner" ? "/seller" : "/buyer"}/dashboard`);
    setProfileDropdown(!profileDropdown);
  };
  const handleCampaigns = () => {
    dispatch(
      setBreadcrumbs([
        {
          title: "Dashboard",
          path: `${userRole === "owner" ? "/seller" : "/buyer"}/dashboard`,
        },
        {
          title: userRole === "owner" ? "Campaigns" : "Campaigns",
          path: `${
            userRole === "owner"
              ? "/seller/viewCampaigns?segment=insertion_order"
              : "/buyer/mycampaigns?segment=saved_campaign"
          }`,
        },
        {
          title: userRole === "owner" ? "Insertion Order" : "Saved Campaigns",
          path: `${
            userRole === "owner"
              ? "/seller/viewCampaigns?segment=insertion_order"
              : "/buyer/mycampaigns?segment=saved_campaign"
          }`,
        },
      ]),
    );
    navigate(
      `${
        userRole === "owner" ? "/seller" : "/buyer"
      }/mycampaigns?segment=saved_campaign`,
    );
    setProfileDropdown(!profileDropdown);
  };
  const handleAggrements = () => {
    handleGoToSubPage({
      title: "Privacy Policy",
      path: `${userRole === "owner" ? "/seller" : "/buyer"}/privacy-policy`,
    });
    navigate(`${userRole === "owner" ? "/seller" : "/buyer"}/privacy-policy`);
    setProfileDropdown(!profileDropdown);
  };
  const handleBrowse = () => {
    dispatch(
      resetBreadcrumbs({
        title: "Shop",
        path: `${userRole === "owner" ? "/seller" : "/buyer"}/products`,
      }),
    );
    navigate(`${userRole === "owner" ? "/seller" : "/buyer"}/products`);
    setProfileDropdown(!profileDropdown);
  };
  const handleAdvertisement = () => {
    SetAdvertise(true);
    setProfileDropdown(false);
  };
  const getInitials = (firstName, lastName) => {
    const firstInitial = firstName?.charAt(0).toUpperCase() || "";
    const lastInitial = lastName?.charAt(0).toUpperCase() || "";
    return `${firstInitial}${lastInitial}`;
  };

  const navigateToPersonalDetails = () => {
    setProfileDropdown(false);
    if (isMobile) {
      const path =
        userRole === "owner"
          ? "/seller/personaldetails"
          : "/buyer/personaldetails";
      navigate(path);
    }
  };

  useEffect(() => {
    if (token) {
      dispatch(getChatHistory({ campaignId: null, bookingId: null }));
      dispatch(getUserProfile());
    }
  }, [dispatch, token]);
  useEffect(() => {
    // Run this Logic only when user cilck on the profile dropdown
    if (!profileDropdown) return;
    const timer = setTimeout(() => {
      if (!nameRef?.current || !emailRef?.current) return;
      const nameOverflow =
        nameRef?.current?.scrollWidth > nameRef?.current?.clientWidth;
      const emailOverflow =
        emailRef?.current?.scrollWidth > emailRef?.current?.clientWidth;
      setIsTruncated((prev) => {
        // This prevents unnecessary re-renders
        if (prev.name === nameOverflow && prev.email === emailOverflow) {
          return prev;
        }
        return {
          name: nameOverflow,
          email: emailOverflow,
        };
      });
    }, 0);
    // This prevents memory Leaks
    return () => clearTimeout(timer);
  }, [profileDropdown]);
  const personalDetailsMenu = () => {
    return (
      <>
        {" "}
        {!termsPlanSelected ? (
          <div className="user-details-popover">
            <Menu style={{ padding: "0.75rem 0.5rem 0.75rem 0.875rem" }}>
              <Menu.Item key="1">
                <div className="navbar-div">
                  <div className="profile-section">
                    {user?.image?.length > 0 ? (
                      <Image
                        src={`${API_BASE_URL_IMAGE}${user?.image[0]}`}
                        alt="Profile"
                        className="profile-image-dropdown"
                        preview={false}
                      />
                    ) : (
                      <Avatar
                        size={64}
                        className="navbar-avatar"
                        preview={false}
                      >
                        {getInitials(user?.first_name, user?.last_name)}
                      </Avatar>
                    )}
                  </div>
                  <div
                    className={`${
                      userRole != "basic" ? "align-section" : ""
                    } profile-details`}
                  >
                    <Tooltip title={isTruncated.name ? user?.name : null}>
                      <span
                        ref={nameRef}
                        className="profile-name truncate-text"
                      >
                        {user?.name}
                      </span>
                    </Tooltip>

                    <Tooltip title={isTruncated.email ? user?.email : null}>
                      <span
                        ref={emailRef}
                        className="profile-email truncate-text"
                      >
                        {user?.email}
                      </span>
                    </Tooltip>
                    {userRole == "basic" && (
                      <span
                        className="edit-profile"
                        onClick={handlePersonalDetails}
                      >
                        Edit Profile
                      </span>
                    )}
                  </div>
                </div>
              </Menu.Item>
              {userRole == "owner" && (
                <Menu.Item
                  key="2"
                  icon={<AccountIcon className="personal-details-icons" />}
                  className="personal-details-menu-list"
                  onClick={handlePersonalDetails}
                >
                  <span className="personal-details-menu-list">My Account</span>
                </Menu.Item>
              )}
              {userRole == "basic" && (
                <>
                  <Menu.Item
                    key="3"
                    icon={<DashboardIcon className="personal-details-icons" />}
                    className="personal-details-menu-list"
                    onClick={handleDashBoard}
                  >
                    <span className="personal-details-menu-list">
                      {userRole === "owner" ? "Dashboard" : "Dashboard"}
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="8"
                    icon={<CartIcons className="personal-details-icons" />}
                    className="personal-details-menu-list"
                    onClick={handleCart}
                  >
                    <span className="personal-details-menu-list">
                      {userRole === "owner" ? "Cart" : "Cart"}
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="12"
                    icon={<Browse className="personal-details-icons" />}
                    className="personal-details-menu-list"
                    onClick={handleBrowse}
                  >
                    <span className="personal-details-menu-list">
                      {userRole === "owner" ? "Shop" : "Shop"}
                    </span>
                  </Menu.Item>
                </>
              )}

              {/* combined for the both users buyers and seller */}
              {/* <Menu.Item
                key="4"
                icon={
                  <BillingAndPaymentIcon className="personal-details-icons" />
                }
                className="personal-details-menu-list"
                onClick={handlePayments}
              >
                <span className="personal-details-menu-list">
                  {userRole === "owner" ? "Payments" : "Billing and Payments"}
                </span>
              </Menu.Item> */}
              <Menu.Item
                key="5"
                icon={
                  <EnquiryChat
                    className="enquiry-menu-chat-icon"
                    style={{ fill: "black" }}
                  />
                }
                className="personal-details-menu-list"
                onClick={handleAdvertisement}
              >
                <span className="personal-details-menu-list">
                  Advertise with AMP
                </span>
              </Menu.Item>
              {userRole == "basic" && (
                <>
                  <Menu.Item
                    key="9"
                    icon={
                      <RFPIcon
                        className="enquiry-menu-chat-icon"
                        style={{ fill: "black" }}
                      />
                    }
                    className="personal-details-menu-list"
                    onClick={(e) => {
                      setRFP(true);
                    }}
                  >
                    <span className="personal-details-menu-list">RFP</span>
                  </Menu.Item>

                  <Menu.Item
                    key="10"
                    icon={<SavedCampaigns className="personal-details-icons" />}
                    className="personal-details-menu-list"
                    onClick={handleCampaigns}
                  >
                    <span className="personal-details-menu-list">
                      {userRole === "owner" ? "Campaigns" : "Campaigns"}
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="11"
                    icon={<Aggrements className="personal-details-icons" />}
                    className="personal-details-menu-list"
                    onClick={handleAggrements}
                  >
                    <span className="personal-details-menu-list">
                      {userRole === "owner"
                        ? " User Agreements"
                        : " User Agreements"}
                    </span>
                  </Menu.Item>
                </>
              )}
              {userRole === "owner" ? (
                <>
                  <Menu.Item
                    key="6"
                    icon={
                      <TermsRequestIcon className="personal-details-icons" />
                    }
                    className="personal-details-menu-list"
                  >
                    <span
                      className="personal-details-menu-list"
                      onClick={() => {
                        handleGoToSubPage({
                          title: "Buyer Request",
                          path: "/seller/terms-requests",
                        });
                        navigate("/seller/terms-requests");
                      }}
                    >
                      Buyer Requests
                    </span>
                  </Menu.Item>
                </>
              ) : (
                <></>
              )}
              <Menu.Item
                key="7"
                icon={<LogoutIcon className="personal-details-icons" />}
                className="personal-details-menu-list"
                onClick={() => {
                  handleLogout();
                }}
              >
                <span className="personal-details-menu-list">Logout</span>
              </Menu.Item>
            </Menu>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };
  const handleLogout = () => {
    message.success("You have successfully signed out!");
    localStorage.clear();
    dispatch(logout());
    disconnectWebSocket();
    dispatch(RESET_USER());
    dispatch(clearAllProductFilters());
    dispatch(setMapView(false));
    dispatch(resetBreadcrumbs({ title: "", path: "" }));
    const uniqueSessionId = nanoid();
    sessionStorage.setItem("sessionId", uniqueSessionId);
    navigate("/");
  };

  function applyStylesToMenuItems() {
    const menuItems = document.querySelectorAll("li[data-menu-id]");
    menuItems.forEach((item) => {
      item.style.order = "1";
    });
  }

  // Apply styles initially
  applyStylesToMenuItems();

  // Monitor changes if the DOM or attributes are updated
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-menu-id"
      ) {
        applyStylesToMenuItems();
      }
    });
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ["data-menu-id"],
  });
  const handleCancel = () => {
    form.resetFields();
    setSelectedTransferProducts([]);
    setRFP(false);
  };

  const handleProfileDropdown = (visible) => {
    setProfileDropdown(visible);
  };
  const handleNotificationPopover = () => {
    setOpenNotificationPopover(!openNotificationPopover);
  };

  const getCleanPath = (path) => path?.split("?")[0];
  const navigateToLeadGeneration = () => {
    if (isLoggedIn) {
      if (userType === "basic") {
        goToSubPage({
          title: "Lead Generation",
          path: "/buyer/get-in-touch",
        });
        navigate("/buyer/get-in-touch", {
          state: { selectedUser: userType },
        });
      }
    } else {
      goToSubPage({ title: "Lead Generation", path: "/buyer/get-in-touch" });
      navigate("/get-in-touch");
    }
  };
  return (
    <>
      <div className="navbar-container">
        {!isMobile ? (
          /** Desktop view resolution */
          <div style={{ width: "100%" }}>
            <Row className="navbar-row" gutter={[16, 16]}>
              <Col className="navbar-logo" md={3} xl={6} xxl={7} lg={5}>
                <div className="logo">
                  <NavLink
                    onClick={(e) => {
                      if (userRole === "owner") {
                        e.preventDefault();
                        navigate("/seller/dashboard");
                      } else {
                        e.preventDefault();
                        dispatch(resetBreadcrumbs({ title: "", path: "" }));
                        navigate("/home");
                      }
                    }}
                  >
                    <Image
                      src={AmpSvg}
                      alt="amp-logo"
                      preview={false}
                      className="logo-red"
                    />
                  </NavLink>
                </div>
              </Col>
              <Col
                md={12}
                xl={userRole === "owner" ? 12 : 9}
                xxl={8}
                lg={userRole === "owner" ? 13 : 9}
                className="navbar-menu"
              >
                <Menu
                  className="navbar-menu-items"
                  mode="horizontal"
                  selectedKeys={[location.pathname]}
                  onClick={handleMenuClick}
                >
                  {menuItems?.map((item) => {
                    const currentPath = location.pathname; // "/buyer/mycampaigns"
                    const menuPath = getCleanPath(item?.key); // "/buyer/mycampaigns"
                    const isActive =
                      currentPath === menuPath ||
                      currentPath.startsWith(menuPath + "/");

                    return (
                      <Menu.Item key={item?.key} className="menu-item">
                        <NavLink
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(item?.key);
                          }}
                          className={`menu-link ${isActive ? "active" : ""}`}
                          style={{
                            color: isActive ? "#D2042D" : "#0A0F0D",
                            fontWeight: isActive ? "bold" : "normal",
                          }}
                        >
                          {item.label === "Messages" ? (
                            <span className="messages-menu-wrapper">
                              Messages
                              {isLiveMsgNotification?.length > 0 && (
                                <Badge
                                  count={isLiveMsgNotification.length}
                                  color="#d2042d"
                                  className="messages-count-badge"
                                />
                              )}
                            </span>
                          ) : (
                            item.label
                          )}
                        </NavLink>

                        {isActive && <div className="active-indicator" />}
                      </Menu.Item>
                    );
                  })}
                </Menu>
              </Col>
              <Col
                md={8}
                xl={userRole === "owner" ? 4 : 9}
                xxl={8}
                lg={userRole === "owner" ? 5 : 9}
                //  className="navbar-actions"
                className={
                  userRole === "owner"
                    ? "navbar-actions-with-rfp"
                    : "navbar-actions"
                }
              >
                {userRole !== "owner" && (
                  <>
                    {!isLoggedIn && (
                      <div className="submit-rfp-container">
                        <Text
                          className="navbar-link-RFP-btn get-in-touch-nav"
                          onClick={navigateToLeadGeneration}
                        >
                          Get in touch
                        </Text>
                      </div>
                    )}
                    <div className="submit-rfp-container">
                      <NavLink>
                        <Text
                          className="navbar-link-RFP-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            setRFP(true);
                          }}
                        >
                          Submit an RFP
                        </Text>
                      </NavLink>
                    </div>
                  </>
                )}
                {!token ? (
                  <>
                    <div className="submit-rfp-container">
                      <Link to="signup">
                        {" "}
                        <Text className="navbar-link">Register</Text>
                      </Link>
                    </div>
                    <div className="submit-rfp-container">
                      <Button
                        type="primary"
                        className="navbar-text"
                        onClick={() => {
                          navigate("/login");
                        }}
                      >
                        Login
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    {/* {userRole === "owner" && (
                      <Badge
                        count={
                          isLiveMsgNotification && isLiveMsgNotification?.length
                        }
                        color="#d2042d"
                      >
                        <div
                          className="chat-notification-icons"
                          onClick={handleChatClick}
                        >
                          <ChatNotification />
                        </div>
                      </Badge>
                    )} */}
                    <Popover
                      classNames={{ root: "notificationPopover" }}
                      content={notificationContent}
                      title={notificationHeader}
                      trigger="click"
                      open={openNotificationPopover}
                      onOpenChange={handleNotificationPopover}
                    >
                      <Badge count={notification_count} color="#d2042d">
                        <Image
                          className="action-icons"
                          src={Notification}
                          preview={false}
                          alt="notification"
                        />
                      </Badge>
                    </Popover>
                    {userRole !== "owner" && (
                      <Badge
                        count={campaignCartDetails?.length}
                        color="#d2042d"
                      >
                        <Image
                          src={CartIcon}
                          preview={false}
                          alt="carticon"
                          className="action-icons"
                          onClick={(e) => {
                            e.preventDefault();
                            handleGoToSubPage({
                              title: "Cart",
                              path: "/buyer/viewcart",
                            });
                            navigate("buyer/viewcart");
                          }}
                        />
                      </Badge>
                    )}
                    <div className="user-actions-bar">
                      <Space direction="horizontal" size={isTab ? 20 : 38}>
                        <Dropdown
                          overlay={personalDetailsMenu()}
                          placement="bottomRight"
                          trigger={["click"]}
                          open={profileDropdown}
                          onOpenChange={handleProfileDropdown}
                        >
                          <div className="profile-image-container">
                            {user?.image?.length > 0 ? (
                              <Image
                                src={`${API_BASE_URL_IMAGE}${user?.image[0]}`}
                                alt="Profile"
                                className="nav-main-profile-image"
                                preview={false}
                                width={32}
                                height={32}
                                onClick={navigateToPersonalDetails}
                              />
                            ) : user?.first_name && user?.last_name ? (
                              <div
                                className="nav-main-profile-image-initials-avatar"
                                onClick={navigateToPersonalDetails}
                              >
                                {getInitials(user?.first_name, user?.last_name)}
                              </div>
                            ) : (
                              <Avatar
                                size={32}
                                icon={<UserOutlined />}
                                onClick={navigateToPersonalDetails}
                              />
                            )}
                            <div className="personal-details-dropdown-container">
                              <DownOutlined style={{ color: "#D2042D" }} />
                            </div>
                          </div>
                        </Dropdown>
                      </Space>
                    </div>
                  </>
                )}
                {/* </div> */}
              </Col>
            </Row>
          </div>
        ) : (
          /** Mobile view resolution */
          <div>
            {!openRfpVersion && (
              <>
                <Row>
                  <Col span={18} className="navbar-logo">
                    <div className="logo">
                      <NavLink
                        onClick={(e) => {
                          if (userRole === "owner") {
                            e.preventDefault();
                            navigate("/seller/dashboard");
                          } else {
                            e.preventDefault();
                            navigate("/home");
                          }
                        }}
                      >
                        <Image
                          src={AmpSvg}
                          alt="amp-logo"
                          preview={false}
                          height={80}
                          width={120}
                        />
                      </NavLink>
                    </div>
                  </Col>
                  <Col span={6} className="navbar-mobile">
                    {!user ? (
                      <>
                        <Col span={16} className="user-navbar-mobile-image-col">
                          <Image
                            src={LoginSvg}
                            alt="login-logo"
                            preview={false}
                            height={24}
                            width={24}
                            className="login-icon"
                            onClick={() => {
                              navigate("/login");
                            }}
                          />
                        </Col>
                      </>
                    ) : (
                      <>
                        <div className="user-badge-image-div">
                          {/* {userRole === "owner" && (
                            <Badge
                              count={
                                isLiveMsgNotification &&
                                isLiveMsgNotification?.length
                              }
                              color="#d2042d"
                            >
                              <div
                                className="chat-notification-icons"
                                onClick={handleChatClick}
                              >
                                <ChatNotification />
                              </div>
                            </Badge>
                          )} */}
                          <Space direction="horizontal" size={15}>
                            <Badge count={notification_count} color="#d2042d">
                              <Image
                                className="action-icons"
                                src={Notification}
                                preview={false}
                                alt="notification"
                                onClick={() => {
                                  userRole == "owner"
                                    ? navigate("/seller/notifications")
                                    : navigate("/buyer/notifications");
                                }}
                              />
                            </Badge>
                            {userRole !== "owner" && (
                              <Badge
                                count={campaignCartDetails?.length}
                                color="#d2042d"
                              >
                                <Image
                                  src={CartIcon}
                                  preview={false}
                                  alt="cart-icon"
                                  height={30}
                                  width={30}
                                  onClick={() => navigate("buyer/viewcart")}
                                />
                              </Badge>
                            )}
                            {user?.image?.length > 0 ? (
                              <Image
                                src={`${API_BASE_URL_IMAGE}${user.image[0]}`}
                                alt="Profile"
                                className="nav-main-profile-image"
                                preview={false}
                                size={32}
                                onClick={navigateToPersonalDetails}
                              />
                            ) : user?.first_name && user?.last_name ? (
                              <div
                                className="nav-main-profile-image-initials-avatar"
                                onClick={navigateToPersonalDetails}
                              >
                                {getInitials(user.first_name, user.last_name)}
                              </div>
                            ) : (
                              <Avatar
                                size={32}
                                icon={<UserOutlined />}
                                onClick={navigateToPersonalDetails}
                              />
                            )}
                          </Space>
                        </div>
                      </>
                    )}
                    <Col span={8}>
                      <MenuOutlined
                        onClick={showDrawer}
                        className="menu-icon"
                      />
                    </Col>
                    <Drawer
                      size="default"
                      placement="left"
                      title={
                        <div className="navbar-drawer">
                          <Button
                            type="text"
                            onClick={closeDrawer}
                            icon={<CloseOutlined />}
                            style={{ fontSize: "16px" }}
                          />
                        </div>
                      }
                      closable={false}
                      onClose={() => setVisible(false)}
                      open={visible}
                      height="100%"
                      className="menu-drawer"
                    >
                      <Menu mode="vertical" selectedKeys={[location.pathname]}>
                        {menuItems?.map((item) => (
                          <Menu.Item
                            key={item.key || item.label}
                            onClick={() => {
                              closeDrawer();
                              if (item.label === "Advertise with AMP") {
                                handleAdvertisement();
                              }
                              if (item.label === "RFP") {
                                navigate("/rfp");
                              }
                              if (item.label === "Get in Touch") {
                                navigate("/get-in-touch");
                                return;
                              }
                            }}
                            className="navbar-menu-items"
                          >
                            {item.key ? (
                              <NavLink to={item.key}>{item.label}</NavLink>
                            ) : (
                              <span>{item.label}</span>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu>
                    </Drawer>
                  </Col>
                </Row>
                <>
                  {location?.pathname === "/home" ? (
                    <>
                      <Row
                        justify={"space-around"}
                        className="navbar-actions-row"
                        align={"middle"}
                      >
                        <Col>
                          {" "}
                          <Text className="submit-your-request-nav-bar">
                            Submit your Ad request
                          </Text>{" "}
                        </Col>
                        <Col>
                          <Text
                            className="navbar-link"
                            onClick={() => {
                              navigate("/rfp");
                            }}
                          >
                            Submit an RFP
                          </Text>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              </>
            )}
            {openRfpVersion && (
              <>
                <div className="navbar-back-button">
                  <BackArrow
                    onClick={() => {
                      navigate("-1");
                    }}
                  />
                  <span className="campaign  my-campaign">Submit Your RFP</span>
                </div>
                <RfpMobileVersion />
              </>
            )}
          </div>
        )}
      </div>
      <Modal
        open={RFP}
        onCancel={handleCancel}
        footer={null}
        centered
        maskClosable={false}
        width="78.438rem"
        height="85%"
        className="submit-rfp-modal-view"
      >
        <RFPModal
          setRFP={setRFP}
          form={form}
          selectedTransferProducts={selectedTransferProducts}
          setSelectedTransferProducts={setSelectedTransferProducts}
        />
      </Modal>
      <Modal
        open={Advertise}
        onCancel={() => {
          setSelectedImage(null);
          SetAdvertise(false);
          form.resetFields();
        }}
        footer={null}
        width="58.438rem"
        height="85%"
        className="custom-advertise-modal"
      >
        <AdvertiseModal
          form={form}
          Advertise={Advertise}
          SetAdvertise={SetAdvertise}
          setSelectedImageForDesktop={setSelectedImage}
          selectedImageForDesktop={selectedImage}
        />
      </Modal>
      <Modal
        open={adVersionOpen}
        footer={null}
        onCancel={() => {
          setSelectedImage(null);
          setAdVersionOpen(false);
          form.resetFields();
        }}
        width="58.438rem"
        className="custom-advertise-modal-version"
      >
        <AdvertiseVersion
          form={form}
          adVersionOpen={adVersionOpen}
          setAdVersionOpen={setAdVersionOpen}
          setSelectedImageForDesktop={setSelectedImage}
          selectedImageForDesktop={selectedImage}
        />
      </Modal>
      {!isMobile && userRole === "owner" && (
        <div className="chatbox-modal-desktop">
          <ChatBoxModal canvasWidth={!isProductChat ? 625 : 860} />
        </div>
      )}
      {isCartLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};

export default NavBar;
